import React from "react"
import {createRoot} from "react-dom/client"
import {BrowserRouter} from "react-router-dom"

import {MsalProvider} from "@azure/msal-react"
import {ThemeProvider} from "@irati/ui/src/global/useTheme"
import {StyleSheetManager} from "styled-components"
import isPropValid from "@emotion/is-prop-valid"

// various 3rd parties
import sentry from "@irati/utils/services/sentry"
import ga4Tracking from "@irati-web/tracking"
import {msalInstance} from "@irati-web/platform/src/utils/microsoftapis/index"
import {getClarityID} from "@irati/utils/microsoftClarity"
import domain from "@irati/utils/env/domain"
import "@irati/utils/intercom"
import "@irati/braze"
import Clarity from "@microsoft/clarity"
import {setupStore} from "./redux/setupStore"
import App from "./routes/index"

// Global css - Bootstrap CSS loaded via index.html for CSP compliance
import "react-redux-toastr/lib/css/react-redux-toastr.min.css"
import {setupPhraseWindowFn} from "./phrase"
import "react-material-symbols/outlined"

ga4Tracking.init()
setupStore()
setupPhraseWindowFn()

if (!domain.isInternal()) {
  Clarity.init(getClarityID())
}

sentry.context(() => {
  /** Start the app */

  createRoot(document.getElementById("root")!).render(
    <MsalProvider instance={msalInstance()}>
      <BrowserRouter>
        <ThemeProvider>
          <StyleSheetManager
            shouldForwardProp={(propName, target) => {
              return typeof target === "string" ? isPropValid(propName) : true
            }}>
            <App />
          </StyleSheetManager>
        </ThemeProvider>
      </BrowserRouter>
    </MsalProvider>
  )
  if (import.meta.hot) import.meta.hot.accept()
})

// Handle outlines for mouse / keyboard users
document.body.addEventListener("keyup", function (e) {
  if (e.which === 9) {
    /* tab */
    document.documentElement.classList.remove("no-focus-outline")
  }
})

document.body.addEventListener("mousedown", function () {
  document.documentElement.classList.add("no-focus-outline")
})
